import React from 'react'

const ColumnOtherAmount = () => {
  return (
    <div>ColumnOtherAmount</div>
  )
}

export default ColumnOtherAmount